export default __webpack_public_path__ + "static/media/Bg.250bcbb7.png";